export enum CabinInsuranceType {
  CABIN_STANDARD = "cabinStandard",
  CABIN_SUPER = "cabinSuper",
}

export enum NotSuperReasonCabin {
  TOO_OLD_CABIN = "oldCabin",
  HAS_DAMAGE_FROM_PESTS = "pestsDamage",
  HAS_CRAWL_SPACE = "crawlSpace",
}
